export enum EPanoramaStatus {
  Loaded,
  None,
}

export interface IPanoramaState {
  status: EPanoramaStatus | null;
}
